import { koKR } from "@clerk/localizations";

// `@clerk/types`를 직접 의존하지 않으려고 값에서 타입을 끌어온다 — 그 패키지는
// clerk-react의 전이 의존이라 직접 import 하면 버전이 어긋날 수 있다.
type Localization = typeof koKR;

/**
 * Clerk UI(로그인·가입·계정 메뉴)의 언어를 **브라우저 설정에 맞춘다.**
 *
 * 안 맞추면 앱 전체가 한국어인데 첫 화면만 "Sign in to …"로 뜬다(실측).
 *
 * 왜 한국어와 기본값(영어) 둘뿐인가: **앱 자체의 문구가 한국어 전용**이다.
 * 로그인 카드만 제3의 언어로 바꿔봐야 그다음 화면이 전부 한국어라 더 헷갈린다.
 * 그래서 "한국어 브라우저면 한국어, 아니면 Clerk 기본값(영어)"까지만 한다.
 *
 * 언어를 늘리려면 여기 한 줄씩 추가하면 되지만, 로케일 하나가 번들에 통째로
 * 실린다는 점을 감안할 것.
 */
export function clerkLocalization(): Localization | undefined {
  // 서버 렌더가 없으므로 navigator는 항상 있지만, 방어적으로 둔다.
  const langs = typeof navigator === "undefined" ? [] : navigator.languages ?? [navigator.language];
  for (const lang of langs) {
    if (!lang) continue;
    // "ko", "ko-KR", "ko-Kore-KR" 모두 잡는다.
    if (lang.toLowerCase().split("-")[0] === "ko") return koKR;
  }
  return undefined; // Clerk 기본값(영어)
}
